import React, { useCallback, useEffect, useRef, useState } from 'react';

// 🔐 Konsollar — tashqi konsollarga (Firebase Crashlytics / Play Console /
// App Store Connect) SERVERDAGI brauzer orqali kirish.
//
// LOGIN'ni OPERATOR qiladi: quyidagi jonli ekranga bosadi va yozadi, harakatlar
// serverdagi brauzerga uzatiladi. Agent parol/2FA kiritmaydi — u faqat O'QIYDI.
// Kadr `/console/frame` dan blob bo'lib olinadi (auth header kerak, shuning uchun
// <img src=...> emas — token URL'ga QO'YILMAYDI).

const CHIP = {
  yes: 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300',
  no: 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-300',
  unknown: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400',
};

export default function ConsolePanel({ authFetch, apiUrl, deepLink, onDeepLinkDone, appProjectId }) {
  const [profiles, setProfiles] = useState([]);
  const [writeEnabled, setWriteEnabled] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [kinds, setKinds] = useState([]);
  const [newKind, setNewKind] = useState(null);   // ➕ yangi XIZMAT turi (Cloudflare, Contabo...)
  const [allProjects, setAllProjects] = useState([]);
  // 🎯 Ish QAYSI loyiha uchun — agent to'g'ri ilovani tanlashi uchun SHART
  // (App Store Connect'da bir nechta ilova bor). Deep-link'dan keladi yoki qo'lda tanlanadi.
  const [runProject, setRunProject] = useState('');
  const [newAcc, setNewAcc] = useState(null);   // {key,label,kind} yoki null
  // 🎯 Loyiha filtri (2026-10-08): yuqorida tanlangan loyihaning konsollari; «Hammasi» — boshqalarini ko'rib biriktirish.
  const [showAll, setShowAll] = useState(false);
  const [myRoles, setMyRoles] = useState({});        // {projectId: 'owner'|...}
  const [missingKinds, setMissingKinds] = useState([]);
  const [active, setActive] = useState(null);      // ochiq sessiya profili
  const [frameUrl, setFrameUrl] = useState(null);
  // 🔗 Agent brauzeri AYNI DAMDA qaysi manzilda turibdi. Kadr javobining
  // X-Kh-Url sarlavhasidan olinadi — alohida so'rov qilinmaydi va manzil
  // kadrdan orqada qolmaydi (ikkalasi bitta javobdan keladi).
  const [pageUrl, setPageUrl] = useState(null);
  // 📋 Saytning O'Z nusxa tugmasi (Payme «Копировать ID» …) serverdagi brauzerga yozadi — kadr sarlavhasidagi
  // X-Kh-Clip (tartib raqami) oshsa matnni olib SIZNING clipboard'ingizga o'tkazamiz (2026-10-10).
  const [clipToast, setClipToast] = useState(null);   // {text, copied}
  const lastClipRef = useRef(null);                   // null = birinchi kadr hali kelmagan (eski nusxa chiqmasin)
  const clipBusyRef = useRef(false);
  // 🔑 Ekrandagi kalitni QO'LDA ko'chirmasdan Sirlarga saqlash. Jonli ekran —
  // rasm, undan nusxa olib bo'lmaydi; qiymat serverdagi sahifadan o'qiladi va
  // shifrlangan holda Sirlarga yoziladi (bu yerda hech qachon ko'rsatilmaydi).
  const [grab, setGrab] = useState(null);          // {name, moduleId, scope}
  const [grabMods, setGrabMods] = useState([]);    // [{id, label}]
  // 🔑 Kirish ma'lumoti (2026-10-10, docs 167): login+parol serverda SHIFRLANGAN, bu yerga hech qachon qaytmaydi —
  // faqat niqoblangan login. «🔑 Kirish» bosilganda server o'zi formaga yozadi; SMS kodini operator kiritadi.
  const [cred, setCred] = useState(null);           // {saved, loginHint, origin, updatedAt, canManage, log[]}
  const [credForm, setCredForm] = useState(null);   // {login, password} | null
  const [credBusy, setCredBusy] = useState(false);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');
  const [text, setText] = useState('');
  const [fullscreen, setFullscreen] = useState(false);  // ⛶ to'liq ekran (emulatordagi kabi)
  // 🤖 Agent ishi: "men kiraman, qolganini sen qil"
  const [wish, setWish] = useState('');
  // 📋 Konsol turiga biriktirilgan TARTIB (playbook) ochiq/yopiq. Tartib agentga
  // AVTOMATIK qo'shiladi — operator uni ko'chirib yozishi shart emas, shuning uchun
  // bu yerda faqat «bor va nimadan iborat» ko'rsatiladi.
  const [showPlaybook, setShowPlaybook] = useState(false);
  // 💬 Agent savol berganda javob matni. Savol kelganda so'rov tezroq bo'lsin —
  // 4 soniya kutish suhbatni sekinlashtiradi.
  const [answer, setAnswer] = useState('');
  const [answering, setAnswering] = useState(false);
  const [consoleRun, setConsoleRun] = useState(null);   // {running, log[], result}
  const [starting, setStarting] = useState(false);

  // authFetch REF orqali — aks holda har renderда effekt qayta ishga tushib
  // refetch-storm bo'ladi (hujjatlangan tuzoq).
  const afRef = useRef(authFetch);
  useEffect(() => { afRef.current = authFetch; }, [authFetch]);
  const activeRef = useRef(null);
  useEffect(() => { activeRef.current = active; }, [active]);
  const objUrlRef = useRef(null);
  const didAutoAttachRef = useRef(false);

  const load = useCallback(async () => {
    try {
      const r = await afRef.current(`${apiUrl}/console/profiles${appProjectId ? `?projectId=${encodeURIComponent(appProjectId)}` : ''}`);
      const d = await r.json().catch(() => null);
      if (r.ok && d && Array.isArray(d.profiles)) {
        setProfiles(d.profiles);
        setWriteEnabled(!!d.writeEnabled);
        setIsAdmin(!!d.isAdmin);
        setKinds(d.kinds || []);
        setAllProjects(d.allProjects || []);
        setMyRoles(d.myRoles || {});
        setMissingKinds(Array.isArray(d.missingKinds) ? d.missingKinds : []);
        // Sahifa yangilangach TIRIK sessiyaga qayta ulanamiz — open() CHAQIRMAYMIZ
        // (navigatsiya yo'q, ochiq sahifa saqlanadi), faqat kadrni ko'rsatamiz. BIR martalik
        // (deepLink'siz), aks holda foydalanuvchi «Ko'rinishni yopish» qilsa 15s da qayta ochilardi.
        if (!activeRef.current && !didAutoAttachRef.current && !deepLink) {
          didAutoAttachRef.current = true;
          const running = d.profiles.find(p => p.running);
          if (running) setActive(running.key);
        }
      }
    } catch (e) { /* o'tkinchi xato — ro'yxat saqlanadi */ }
  }, [apiUrl, deepLink, appProjectId]);

  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  // Reja kartasidan kelgan vazifa matnini maydonga qo'yamiz (deepLink.task).
  useEffect(() => { if (deepLink && deepLink.task) setWish(String(deepLink.task)); }, [deepLink]);
  // 📋 Reja kartasi konteksti — DEEP-LINK O'CHGANDAN KEYIN HAM saqlanadi.
  // 🔴 GOTCHA: deep-link effekti konsolni ochgach `onDeepLinkDone()` chaqiradi va
  // `deepLink` NULL bo'ladi. Ilgari `todoId` to'g'ridan-to'g'ri `deepLink`dan
  // o'qilardi, ya'ni operator ▶ Boshlash bosgunicha bog'lanish YO'QOLARDI —
  // ish bajarilar, lekin natija reja kartasiga qaytmasdi (run #9).
  const [cardCtx, setCardCtx] = useState(null);     // boshlanishini kutayotgan karta
  const [linkedCard, setLinkedCard] = useState(null); // allaqachon bog'langan karta
  useEffect(() => {
    if (deepLink && deepLink.todoId) {
      setCardCtx({ todoId: deepLink.todoId, todoTitle: deepLink.todoTitle || 'reja kartasi' });
      setLinkedCard(null);
    }
  }, [deepLink]);
  const fromCard = cardCtx || linkedCard;
  useEffect(() => { if (deepLink && deepLink.projectId) setRunProject(String(deepLink.projectId)); }, [deepLink]);

  // 🎯 LOYIHA O'ZI TANLANADI — operator uni qayta tanlab o'tirmasin.
  //
  // Jonli holat (ish #19): tepadagi panelda «TezHal» turgan, konsolda esa
  // «— tanlanmagan —» edi va operator buni ko'rmadi → agentga modul manzillari
  // ham, integratsiya hisoboti ham berilmadi va u Endpoint URL, rekvizit nomi va
  // regexini qaytadan so'radi. Operator: «tepada loyiha tanlangan, nimaga
  // konsolda tanlov yo'q».
  //
  // Tartib: (1) tepadagi tanlangan loyiha — LEKIN u shu konsolga biriktirilgan
  // bo'lsa (aks holda begona loyiha faktlari ketardi); (2) profil faqat bitta
  // loyihaga bog'langan bo'lsa — o'sha. Ikkalasi ham bo'lmasa TAXMIN QILMAYMIZ.
  useEffect(() => {
    if (!active || runProject) return;
    const p = profiles.find(x => x.key === active);
    const linked = (p && p.projects) || [];
    const top = appProjectId ? String(appProjectId) : '';
    if (top && linked.some(x => String(x.id) === top)) { setRunProject(top); return; }
    if (linked.length === 1) { setRunProject(String(linked[0].id)); return; }
    if (top && !linked.length && allProjects.some(x => String(x.id) === top)) setRunProject(top);
  }, [active, profiles, runProject, appProjectId, allProjects]);

  // Agent savol berib turibdimi (javob kutmoqda)?
  const ask = consoleRun && consoleRun.pendingAsk;
  const asking = !!ask;

  // Agent holati — faqat sessiya ochiq bo'lganda va ish ketayotganda so'raladi.
  useEffect(() => {
    if (!active) { setConsoleRun(null); return; }
    let stop = false;
    const tick = async () => {
      try {
        const r = await authFetch(`${apiUrl}/console/run-status?profile=${encodeURIComponent(active)}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!stop) setConsoleRun(d);
      } catch (e) { /* jim */ }
    };
    tick();
    const t = setInterval(tick, asking ? 1500 : 4000);
    return () => { stop = true; clearInterval(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, apiUrl, asking]);

  // 💬 Agent savoliga javob. Variant tugmasi ham, erkin matn ham shu yerdan.
  const sendAnswer = async (text) => {
    const a = String(text || '').trim();
    if (!a || !active) return;
    setAnswering(true);
    try {
      const r = await authFetch(`${apiUrl}/console/answer`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ profile: active, answer: a }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) setMsg('❌ ' + (d.error || 'Javob yuborilmadi'));
      else setAnswer('');
    } catch (e) { setMsg('❌ ' + e.message); } finally { setAnswering(false); }
  };

  const startRun = async () => {
    const w = wish.trim();
    if (w.length < 5 || !active) return;
    setStarting(true); setMsg('');
    try {
      const r = await authFetch(`${apiUrl}/console/run`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          profile: active, wish: w,
          projectId: runProject ? Number(runProject) : ((deepLink && deepLink.projectId) || undefined),
          // Reja kartasidan kelgan bo'lsa — natija o'sha kartaga yoziladi.
          todoId: (cardCtx && cardCtx.todoId) || undefined,
        }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setMsg('❌ ' + (d.error || r.status)); return; }
      // Bog'landi — keyingi (boshqa) ish shu kartaga YOZILMASIN.
      if (cardCtx) { setLinkedCard(cardCtx); setCardCtx(null); }
      setConsoleRun({ running: true, log: [], result: null });
    } catch (e) { setMsg('❌ Server javob bermadi'); }
    finally { setStarting(false); }
  };

  // Jonli kadr: sessiya ochiq bo'lganda ~900ms da bir marta
  useEffect(() => {
    if (!active) {
      if (objUrlRef.current) { URL.revokeObjectURL(objUrlRef.current); objUrlRef.current = null; }
      setFrameUrl(null);
      setPageUrl(null);
      return;
    }
    let stop = false;
    const tick = async () => {
      if (stop || !activeRef.current) return;
      try {
        const r = await afRef.current(`${apiUrl}/console/frame?profile=${encodeURIComponent(activeRef.current)}`);
        if (r.ok) {
          const h = r.headers.get('X-Kh-Url');
          if (!stop) { try { setPageUrl(h ? decodeURIComponent(h) : null); } catch { setPageUrl(h || null); } }
          const cs = parseInt(r.headers.get('X-Kh-Clip') || '0', 10) || 0;
          if (!stop) onSiteClipRef.current(cs);
          const b = await r.blob();
          const u = URL.createObjectURL(b);
          if (objUrlRef.current) URL.revokeObjectURL(objUrlRef.current);
          objUrlRef.current = u;
          if (!stop) setFrameUrl(u);
        }
      } catch (e) { /* kadr o'tkazib yuborildi */ }
    };
    lastClipRef.current = null;
    tick();
    const t = setInterval(tick, 900);
    return () => { stop = true; clearInterval(t); };
  }, [active, apiUrl]);

  // Faol akkauntga bog'langan loyihalarning modullari — sir qaysi modulga
  // yozilishini tanlash uchun.
  const openGrab = async () => {
    setGrab({ name: '', moduleId: '', scope: 'both' });
    try {
      const acc = profiles.find(p => p.key === activeRef.current);
      const projs = (acc && acc.projects) || [];
      const out = [];
      for (const pr of projs) {
        const r = await afRef.current(`${apiUrl}/projects/${pr.id}/modules`);
        if (!r.ok) continue;
        const d = await r.json().catch(() => []);
        for (const m of (Array.isArray(d) ? d : (d.modules || []))) {
          out.push({ id: m.id, label: `${pr.name} / ${m.name}` });
        }
      }
      setGrabMods(out);
      if (out.length === 1) setGrab(g => ({ ...(g || {}), moduleId: String(out[0].id) }));
    } catch (e) { setGrabMods([]); }
  };

  const grabSecret = async () => {
    if (!grab || !grab.moduleId) { setMsg('❌ Modulni tanlang'); return; }
    if (!grab.name || grab.name.trim().length < 2) { setMsg('❌ Sir nomini yozing'); return; }
    try {
      const r = await afRef.current(`${apiUrl}/console/grab-secret`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ profile: activeRef.current, moduleId: Number(grab.moduleId), name: grab.name.trim(), scope: grab.scope }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setMsg('❌ ' + (d.error || r.status)); return; }
      const src = d.source === 'selection' ? 'belgilangan matndan'
                : d.source === 'field' ? 'bosilgan maydondan'
                : d.source === 'clipboard' ? 'nusxa olingan matndan' : 'ekrandan';
      setMsg(`✅ ${d.name} saqlandi (${d.length} belgi, ${src}) — qiymat hech qayerda ko'rsatilmaydi`);
      setGrab(null);
    } catch (e) { setMsg('❌ Server javob bermadi'); }
  };

  const post = async (path, body, method = 'POST') => {
    const r = await afRef.current(`${apiUrl}${path}`, {
      method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.error || `Xato ${r.status}`);
    return d;
  };

  // 🔒 Agent ishlayotganda operator boshqaruvi qulflangan (ikkalasi bitta sahifani boshqarib bir-birini chalg'itardi —
  // 2026-09-27). Server ham 423 qaytaradi; boshqarish uchun avval ⏹ to'xtatiladi.
  const agentBusy = !!(consoleRun && consoleRun.running);
  const agentBusyRef = useRef(false); agentBusyRef.current = agentBusy;
  const lockedMsg = () => setMsg("🤖 Agent ishlayapti — boshqarish uchun avval «✋ Agentni to'xtatib, boshqaruvni olish» ni bosing");

  // 🔑 Kirish ma'lumoti — holat (akkaunt ochilganda), saqlash, o'chirish, ishlatish.
  const loadCred = useCallback(async (key) => {
    if (!key) { setCred(null); return; }
    try {
      const r = await afRef.current(`${apiUrl}/console/accounts/${encodeURIComponent(key)}/credentials`);
      setCred(r.ok ? await r.json() : null);
    } catch (e) { setCred(null); }
  }, [apiUrl]);
  useEffect(() => { setCredForm(null); loadCred(active); }, [active, loadCred]);
  const credPath = () => `/console/accounts/${encodeURIComponent(activeRef.current)}/credentials`;
  const saveCred = async () => {
    if (!credForm || !credForm.login.trim() || !credForm.password) { setMsg("❌ Login va parolni yozing"); return; }
    setCredBusy(true);
    try {
      const d = await post(credPath(), { login: credForm.login.trim(), password: credForm.password }, 'PUT');
      setCred(d); setCredForm(null);
      setMsg("✅ Kirish ma'lumoti shifrlab saqlandi — endi «🔑 Kirish» bilan kiriladi (parol hech qayerda ko'rinmaydi)");
    } catch (e) { setMsg('❌ ' + e.message); } finally { setCredBusy(false); }
  };
  const deleteCred = async () => {
    if (!window.confirm("Saqlangan login va parol o'chirilsinmi?")) return;
    setCredBusy(true);
    try { setCred(await post(credPath(), {}, 'DELETE')); setCredForm(null); setMsg("🗑 Kirish ma'lumoti o'chirildi"); }
    catch (e) { setMsg('❌ ' + e.message); } finally { setCredBusy(false); }
  };
  const credLogin = async () => {
    if (agentBusyRef.current) { lockedMsg(); return; }
    setCredBusy(true); setMsg("🔑 Login va parol formaga yozilmoqda…");
    try {
      const d = await post(`/console/accounts/${encodeURIComponent(activeRef.current)}/login`, {});
      const t = {
        need_code: "📨 Tasdiqlash kodi kutilmoqda — kodni jonli ekrandagi maydonga kiriting",
        logged_in: '✅ Kirildi', already: '✅ Allaqachon kirilgan',
        error: '❌ ' + (d.message || "Kirib bo'lmadi"), unknown: 'ℹ️ ' + (d.message || 'Ekranni ko\'ring'),
      }[d.state];
      setMsg(t || ('ℹ️ ' + (d.message || d.state)));
    } catch (e) { setMsg('❌ ' + e.message); } finally { setCredBusy(false); loadCred(activeRef.current); }
  };
  const [stopping, setStopping] = useState(false);
  const stopAgent = async () => {
    if (!activeRef.current) return;
    if (!window.confirm("Agent to'xtatilsinmi?\n\nShu paytgacha qilingan ish (saqlangan sirlar, kabinetdagi o'zgarishlar) qoladi, qolgani to'xtaydi. Keyin brauzerni o'zingiz boshqarasiz.")) return;
    setStopping(true);
    try { await post('/console/stop', { profile: activeRef.current }); setMsg('⏹ Agent to\'xtatilmoqda — bir necha soniyada boshqaruv sizda bo\'ladi.'); }
    catch (e) { setMsg('❌ ' + e.message); }
    finally { setTimeout(() => setStopping(false), 4000); }
  };

  const openSession = async (key, login) => {
    setBusy(key); setMsg('');
    try {
      const r = await post('/console/open', { profile: key, login });
      setActive(key);
      // Sessiya allaqachon tirik bo'lsa login sahifasi ochilmaydi — xabar ham shunga mos.
      setMsg(r.loggedIn
        ? '✅ Sessiya tirik — konsol ochildi, login talab qilinmadi.'
        : '🔐 Login sahifasi ochildi — quyidagi ekranga bosib, kiriting.');
      load();
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setBusy(''); }
  };

  // 🔗 Deep-link: Publish paneli «App Store'ga chiqarish» tugmasi shu profilni AYNAN
  // release sahifasida ochadi (login qilingan ASC sessiyasida). nonce har bosishda o'zgaradi.
  const dlNonceRef = useRef(null);
  useEffect(() => {
    if (!deepLink || !deepLink.profile || deepLink.nonce === dlNonceRef.current) return;
    dlNonceRef.current = deepLink.nonce;
    // 🎙 Boshqaruvchi konsolni ALLAQACHON ishga tushirgan — faqat ulanamiz (open() sahifani qayta
    // ochib agent ishini buzardi).
    if (deepLink.attach) {
      setActive(deepLink.profile);
      setMsg('🎙 Boshqaruvchi ochgan konsol — login kerak bo\'lsa ekranga bosib kiring, qolganini agent qiladi.');
      load();
      if (onDeepLinkDone) onDeepLinkDone();
      return;
    }
    (async () => {
      setBusy(deepLink.profile); setMsg('');
      try {
        const r = await post('/console/open', { profile: deepLink.profile, url: deepLink.url });
        setActive(deepLink.profile);
        setMsg(r.loggedIn
          ? '✅ App Store Connect ochildi — versiyani yaratib, build\'ni biriktirib, «Submit for Review» qiling.'
          : '🔐 Avval Apple hisobiga kiring (ekranga bosib), keyin release sahifasi ochiladi.');
        load();
      } catch (e) { setMsg('❌ ' + e.message); }
      finally { setBusy(''); if (onDeepLinkDone) onDeepLinkDone(); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deepLink]);

  const closeSession = async (key) => {
    setBusy(key);
    try { await post('/console/close', { profile: key }); if (activeRef.current === key) setActive(null); setMsg('Sessiya yopildi.'); load(); }
    catch (e) { setMsg('❌ ' + e.message); }
    finally { setBusy(''); }
  };

  const checkSession = async (key) => {
    setBusy(key); setMsg('⏳ Tekshirilmoqda…');
    try {
      const r = await afRef.current(`${apiUrl}/console/status?profile=${encodeURIComponent(key)}&probe=1`);
      const d = await r.json().catch(() => ({}));
      setMsg(d.loggedIn ? '✅ Sessiya tirik — agent bu konsolni o\'qiy oladi.' : '❌ Kirilmagan yoki sessiya tugagan — «Sessiyani ochish» bilan login qiling.');
      load();
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setBusy(''); }
  };

  // Ekranga bosish → serverdagi brauzer koordinatasi.
  // Kadr eni 100% berilgan, nisbati saqlanadi → miqyos = tabiiy_eni / ko'rinadigan_eni.
  const onScreenClick = async (e) => {
    if (!activeRef.current) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    const img = e.currentTarget;
    if (!img.naturalWidth) return;
    const rect = img.getBoundingClientRect();
    const scale = img.naturalWidth / rect.width;
    const x = Math.round((e.clientX - rect.left) * scale);
    const y = Math.round((e.clientY - rect.top) * scale);
    try { await post('/console/input', { profile: activeRef.current, action: 'click', x, y }); }
    catch (err) { setMsg('❌ ' + err.message); }
  };

  const sendText = async () => {
    if (!activeRef.current || !text) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    try { await post('/console/input', { profile: activeRef.current, action: 'type', text }); setText(''); }
    catch (e) { setMsg('❌ ' + e.message); }
  };

  const sendKey = async (key) => {
    if (!activeRef.current) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    try { await post('/console/input', { profile: activeRef.current, action: 'key', key }); }
    catch (e) { setMsg('❌ ' + e.message); }
  };

  // ⟳ Sahifani qayta yuklash (F5) — kabinet qotib qolsa sessiyani yopmasdan.
  const [reloading, setReloading] = useState(false);
  const reloadPage = async () => {
    if (!activeRef.current || reloading) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    setReloading(true);
    try {
      const r = await post('/console/input', { profile: activeRef.current, action: 'reload' });
      setMsg(r && r.warning ? r.warning : '⟳ Sahifa yangilandi');
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setReloading(false); }
  };

  const sendScroll = async (direction, amount) => {
    if (!activeRef.current) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    try { await post('/console/input', { profile: activeRef.current, action: 'scroll', direction, amount }); }
    catch (e) { setMsg('❌ ' + e.message); }
  };
  // ⌨️📋 KLAVIATURA + NUSXA (2026-10-07, operator: «konsoldan copy qilib emulator/Mac'ga paste qila
  // olmayman; o'ziga to'g'ridan-to'g'ri yozib, paste qilsa bo'lsin»). Kadrni bosgach klaviatura konsolga
  // ulanadi: harflar to'g'ridan-to'g'ri yoziladi, ⌘V/Ctrl+V — qo'yish, ⌘C/Ctrl+C — serverdagi sahifada
  // belgilangan matn SIZNING clipboard'ingizga. Belgilash: sichqoncha bilan sudrash yoki 2/3 marta bosish.
  // So'rovlar NAVBAT bilan ketadi (bosish → yozish tartibi buzilmasin).
  const [kbFocus, setKbFocus] = useState(false);
  const inputChainRef = useRef(Promise.resolve());
  const queueInput = (body) => {
    const p = inputChainRef.current.then(() => post('/console/input', { profile: activeRef.current, ...body }));
    inputChainRef.current = p.catch(() => {});
    return p.catch(err => { setMsg('❌ ' + err.message); return null; });
  };
  const typeBufRef = useRef('');
  const typeTimerRef = useRef(null);
  const flushType = () => {
    clearTimeout(typeTimerRef.current); typeTimerRef.current = null;
    const t = typeBufRef.current; typeBufRef.current = '';
    if (t) queueInput({ action: 'insert', text: t });
  };
  const copyFromConsole = async () => {
    if (!activeRef.current) return;
    flushType();
    const textP = inputChainRef.current
      .then(() => post('/console/copy', { profile: activeRef.current }))
      .then(d => { if (!d || !d.text) throw new Error((d && d.error) || "Belgilangan matn yo'q"); return d.text; });
    textP.catch(() => {});
    try {
      if (window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
        // Safari: clipboard yozuvi bosish (gesture) ichida boshlanishi shart — promise bilan beramiz.
        await navigator.clipboard.write([new window.ClipboardItem({ 'text/plain': textP.then(t => new Blob([t], { type: 'text/plain' })) })]);
      } else {
        await navigator.clipboard.writeText(await textP);
      }
      const t = await textP;
      setMsg(`📋 Nusxalandi (${t.length} belgi) — endi emulator yoki kompyuteringizga qo'yishingiz mumkin`);
    } catch (e) {
      let t = '';
      try { t = await textP; } catch (e2) { setMsg('❌ ' + e2.message); return; }
      try {
        const ta = document.createElement('textarea');
        ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        setMsg(ok ? `📋 Nusxalandi (${t.length} belgi)` : "❌ Brauzer clipboard'ga yozishga ruxsat bermadi");
      } catch (e3) { setMsg("❌ Brauzer clipboard'ga yozishga ruxsat bermadi"); }
    }
  };
  const writeClip = async (t) => {
    try { await navigator.clipboard.writeText(t); return true; } catch (e) {}
    try {
      const ta = document.createElement('textarea');
      ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  };
  const onSiteClip = async (seq) => {
    if (lastClipRef.current === null) { lastClipRef.current = seq; return; }
    if (!(seq > lastClipRef.current) || clipBusyRef.current) return;
    clipBusyRef.current = true;
    try {
      const d = await post('/console/copy', { profile: activeRef.current, source: 'site' });
      lastClipRef.current = Math.max(seq, (d && d.seq) || 0);
      if (!d || !d.text) return;
      const ok = await writeClip(d.text);
      setClipToast({ text: d.text, copied: ok });
      if (ok) setTimeout(() => setClipToast(c => (c && c.text === d.text && c.copied ? null : c)), 4000);
    } catch (e) { lastClipRef.current = seq; }
    finally { clipBusyRef.current = false; }
  };
  const onSiteClipRef = useRef(onSiteClip); onSiteClipRef.current = onSiteClip;
  const KB_SPECIAL = ['Enter', 'Backspace', 'Delete', 'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'];
  const onFrameKeyDown = (e) => {
    if (!activeRef.current) return;
    const k = e.key;
    const mod = e.metaKey || e.ctrlKey;
    if (mod && (k === 'c' || k === 'C')) { e.preventDefault(); copyFromConsole(); return; }
    if (mod && (k === 'v' || k === 'V')) return;   // «paste» hodisasi o'zi ushlaydi
    if (['Shift', 'Meta', 'Control', 'Alt', 'CapsLock'].includes(k)) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    if (mod && /^[axzy]$/i.test(k)) {
      e.preventDefault(); flushType();
      if (k.toLowerCase() === 'x') { copyFromConsole().then(() => queueInput({ action: 'key', key: 'Delete' })); return; }
      // Serverdagi brauzer Linux'da — ⌘ o'rniga Control.
      queueInput({ action: 'key', key: (e.shiftKey ? 'Shift+' : '') + 'Control+' + k.toUpperCase() });
      return;
    }
    if (mod || e.altKey) return;   // ⌘R, ⌘T kabi o'z brauzeringiz yorliqlari o'zingizda qolsin
    if (KB_SPECIAL.includes(k)) {
      e.preventDefault(); flushType();
      queueInput({ action: 'key', key: (e.shiftKey ? 'Shift+' : '') + k });
      return;
    }
    if (k.length === 1) {
      e.preventDefault();
      typeBufRef.current += k;
      if (!typeTimerRef.current) typeTimerRef.current = setTimeout(flushType, 120);
    }
  };
  // Matn keydown'siz kelishi ham mumkin (diktovka, emoji tanlagich, avtomat vositalar) — `beforeinput`
  // insertText'ni ham buferga olamiz. Element bir marta bog'lanadi (callback ref).
  const kbBoundRef = useRef(new WeakSet());
  const kbRef = (el) => {
    if (!el || kbBoundRef.current.has(el)) return;
    kbBoundRef.current.add(el);
    el.addEventListener('beforeinput', (ev) => {
      if (ev.inputType !== 'insertText' || !ev.data) return;
      ev.preventDefault();
      if (!activeRef.current) return;
      if (agentBusyRef.current) { lockedMsg(); return; }
      typeBufRef.current += ev.data;
      if (!typeTimerRef.current) typeTimerRef.current = setTimeout(flushType, 120);
    });
  };
  const onFramePaste = (e) => {
    if (!activeRef.current) return;
    e.preventDefault();
    if (agentBusyRef.current) { lockedMsg(); return; }
    const t = (e.clipboardData && e.clipboardData.getData('text')) || '';
    if (!t) return;
    flushType();
    queueInput({ action: 'insert', text: t }).then(r => { if (r) setMsg(`📥 Qo'yildi (${t.length} belgi)`); });
  };
  const dragRef = useRef(null);
  const frameXY = (img, ev) => {
    const rect = img.getBoundingClientRect();
    const sc = img.naturalWidth / rect.width;
    return { x: Math.round((ev.clientX - rect.left) * sc), y: Math.round((ev.clientY - rect.top) * sc) };
  };
  const onFrameMouseDown = (e) => {
    if (e.button !== 0) return;
    e.preventDefault();                       // rasmni «sudrab olib ketish» o'rniga belgilash
    const img = e.currentTarget;
    if (!img.naturalWidth) return;
    dragRef.current = { ...frameXY(img, e), cx: e.clientX, cy: e.clientY };
  };
  const onFrameMouseUp = (e) => {
    const st = dragRef.current; dragRef.current = null;
    const box = e.currentTarget.closest('[data-kb]');
    if (box) box.focus();
    if (!st || !activeRef.current) return;
    if (agentBusyRef.current) { lockedMsg(); return; }
    const img = e.currentTarget;
    if (!img.naturalWidth) return;
    const end = frameXY(img, e);
    flushType();
    if (Math.hypot(e.clientX - st.cx, e.clientY - st.cy) > 6) { queueInput({ action: 'drag', x: st.x, y: st.y, x2: end.x, y2: end.y }); return; }
    if (e.detail >= 2) { queueInput({ action: 'multiclick', x: end.x, y: end.y, count: Math.min(3, e.detail) }); return; }
    queueInput({ action: 'click', x: end.x, y: end.y });
  };
  const kbBadge = (
    <div className={`absolute left-2 bottom-2 text-[11px] px-2 py-1 rounded shadow pointer-events-none ${kbFocus ? 'bg-emerald-600 text-white' : 'bg-gray-900/70 text-gray-200'}`}>
      {kbFocus ? "⌨️ Klaviatura konsolda — yozing · ⌘V qo'yish · ⌘C nusxa" : '⌨️ Ekranni bosing — klaviatura ulanadi'}
    </div>
  );

  // Sichqoncha g'ildiragi bilan tabiiy scroll — kadr ustida (throttled, sahifani surmaydi).
  const wheelBusyRef = useRef(false);
  const onFrameWheel = (e) => {
    e.preventDefault();
    if (wheelBusyRef.current || !activeRef.current || agentBusyRef.current) return;
    wheelBusyRef.current = true;
    sendScroll(e.deltaY < 0 ? 'up' : 'down', Math.min(900, Math.max(200, Math.abs(e.deltaY) * 3)))
      .finally(() => setTimeout(() => { wheelBusyRef.current = false; }, 250));
  };

  // Akkauntni loyihalarga bog'lash — chipni bosish darhol saqlaydi.
  const toggleProject = async (acc, pid) => {
    const has = (acc.projects || []).some(x => x.id === pid);
    const ids = has ? (acc.projects || []).filter(x => x.id !== pid).map(x => x.id)
                    : [...(acc.projects || []).map(x => x.id), pid];
    try { await post(`/console/accounts/${encodeURIComponent(acc.key)}/projects`, { projectIds: ids }, 'PUT'); load(); }
    catch (e) { setMsg('❌ ' + e.message); }
  };

  const curPid = Number(appProjectId) || null;
  const curProjectName = (allProjects.find(x => Number(x.id) === curPid) || {}).name || '';
  const canManage = (pid) => isAdmin || (pid && myRoles[pid] === 'owner');
  const linkProject = async (acc, on) => {
    if (!curPid) return;
    if (!on && !window.confirm(`«${acc.label}» ${curProjectName} loyihasidan olib tashlansinmi? (Akkaunt va uning sessiyasi qoladi.)`)) return;
    try { await post(`/console/accounts/${encodeURIComponent(acc.key)}/link`, { projectId: curPid, on }); setMsg(on ? `✅ ${curProjectName} loyihasiga biriktirildi` : `➖ ${curProjectName} loyihasidan olib tashlandi`); load(); }
    catch (e) { setMsg('❌ ' + e.message); }
  };
  const splitAccount = async (acc) => {
    if (!curPid) return;
    const others = (acc.projects || []).filter(x => Number(x.id) !== curPid).map(x => x.name).join(', ');
    if (!window.confirm(`«${acc.label}» hozir ${curProjectName} va ${others} uchun umumiy.\n\n${curProjectName} uchun ALOHIDA akkaunt yaratilsinmi? Yangi akkauntga ${curProjectName}ning o'z logini bilan kirasiz; eskisi ${others} uchun qoladi.`)) return;
    try {
      const r = await post(`/console/accounts/${encodeURIComponent(acc.key)}/split`, { projectId: curPid });
      setMsg(`✂️ «${r.account.label}» yaratildi — endi «🔐 Sessiyani ochish» bilan ${curProjectName}ning logini bilan kiring.`); load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  const createAccount = async () => {
    try {
      await post('/console/accounts', { ...newAcc, projectId: curPid || undefined });
      setNewAcc(null); setMsg('✅ Akkaunt qo\'shildi — endi «🔐 Sessiyani ochish» bilan login qiling.'); load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  // ── Yangi KONSOL TURI (xizmat). Ilgari turlar faqat kodda edi (google/apple),
  // ya'ni boshqa xizmat kerak bo'lsa kod o'zgartirish talab qilinardi.
  const createKind = async () => {
    try {
      await post('/console/kinds', newKind);
      setNewKind(null);
      setMsg("✅ Xizmat qo'shildi — endi shu turda akkaunt yarating va sessiyani oching.");
      load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  const removeKind = async (k) => {
    if (!window.confirm(`"${k.label}" xizmati o'chirilsinmi?`)) return;
    try {
      const r = await afRef.current(`${apiUrl}/console/kinds/${encodeURIComponent(k.kind)}`, { method: 'DELETE' });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || `Xato ${r.status}`);
      setMsg("Xizmat o'chirildi."); load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  const deleteAccount = async (acc) => {
    if (!window.confirm(`"${acc.label}" akkaunti o'chirilsinmi? Saqlangan login sessiyasi ham yo'qoladi.`)) return;
    try {
      const r = await afRef.current(`${apiUrl}/console/accounts/${encodeURIComponent(acc.key)}`, { method: 'DELETE' });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || `Xato ${r.status}`);
      if (activeRef.current === acc.key) setActive(null);
      setMsg('Akkaunt o\'chirildi.'); load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  const chip = (p) => {
    if (p.loggedIn === true) return <span className={`text-xs px-2 py-1 rounded ${CHIP.yes}`}>✅ Kirilgan</span>;
    if (p.loggedIn === false) return <span className={`text-xs px-2 py-1 rounded ${CHIP.no}`}>❌ Kirilmagan</span>;
    return <span className={`text-xs px-2 py-1 rounded ${CHIP.unknown}`}>❔ Noma'lum</span>;
  };

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-2">
        <h2 className="text-2xl font-bold">🔐 Konsollar</h2>
        <span className={`text-xs px-2 py-1 rounded ${writeEnabled ? CHIP.no : CHIP.yes}`}>
          {writeEnabled ? '✍️ Yozish YOQILGAN' : '🔒 Faqat o\'qish'}
        </span>
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-5">
        Serverdagi brauzer orqali Firebase Crashlytics / Play Console / App Store Connect'ga kirish.
        <b> Loginni siz qilasiz</b> — parol va 2FA ni quyidagi jonli ekranga o'zingiz kiritasiz;
        agent keyin faqat <b>o'qiydi</b>. Sessiya tugasa 🩺 Salomatlik bo'limi ogohlantiradi.
      </p>

      {msg && <div className="mb-4 text-sm bg-gray-50 dark:bg-gray-700 border rounded px-3 py-2">{msg}</div>}

      {curPid && (
        <div className="flex items-center gap-2 flex-wrap mb-3 text-sm">
          <span className="font-semibold">📁 {curProjectName || 'Loyiha'} konsollari</span>
          <div className="inline-flex rounded border overflow-hidden">
            <button onClick={() => setShowAll(false)} className={`px-3 py-1 text-xs ${!showAll ? 'bg-primary-700 text-white dark:bg-primary-600' : 'text-gray-600 dark:text-gray-400'}`}>
              Shu loyiha ({profiles.filter(p => (p.projects || []).some(x => Number(x.id) === curPid)).length})
            </button>
            <button onClick={() => setShowAll(true)} className={`px-3 py-1 text-xs border-l ${showAll ? 'bg-primary-700 text-white dark:bg-primary-600' : 'text-gray-600 dark:text-gray-400'}`}>
              Hammasi ({profiles.length})
            </button>
          </div>
          {showAll && <span className="text-[11px] text-gray-500 dark:text-gray-400">Boshqa loyihalardagi akkauntni «➕ biriktirish» bilan shu loyihaga ham ulash mumkin (masalan bitta Apple ID).</span>}
        </div>
      )}
      {curPid && missingKinds.length > 0 && (
        <div className="mb-4 flex flex-col gap-2">
          {missingKinds.map(mk => (
            <div key={mk.kind} className="border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 rounded-lg px-3 py-2 text-sm flex items-center gap-2 flex-wrap">
              <span>⚠️ {curProjectName}da <b>{mk.label}</b> integratsiyasi bor, lekin konsol akkaunti biriktirilmagan.</span>
              {canManage(curPid) && (
                <button onClick={() => setNewAcc({ key: '', label: `${mk.label} (${curProjectName})`, kind: mk.kind })}
                  className="ml-auto px-2.5 py-1 text-xs bg-amber-600 text-white rounded">➕ {curProjectName} uchun qo'shish</button>
              )}
              <button onClick={() => setShowAll(true)} className="px-2.5 py-1 text-xs border rounded">Mavjudini biriktirish</button>
            </div>
          ))}
        </div>
      )}

      <div className="grid gap-4 md:grid-cols-2 mb-6">
        {(() => {
          const vis = (curPid && !showAll) ? profiles.filter(p => (p.projects || []).some(x => Number(x.id) === curPid)) : profiles;
          return [...vis].sort((a, b) => String(a.kind).localeCompare(String(b.kind)) || String(a.label).localeCompare(String(b.label)));
        })().map((p) => (
          <div key={p.key} className={`border rounded-lg p-4 ${active === p.key ? 'ring-2 ring-primary-600' : ''}`}>
            <div className="flex items-center justify-between mb-1">
              <div className="font-semibold">{p.label}</div>
              {chip(p)}
            </div>
            {p.hint && <div className="text-xs text-gray-500 dark:text-gray-400 mb-2">{p.hint}</div>}
            <div className="text-[11px] text-gray-400 mb-2 break-all">
              Ruxsat etilgan: {(p.origins || []).join(', ')}
            </div>
            <div className="mb-3">
              <div className="text-[11px] text-gray-500 dark:text-gray-400 mb-1">
                Loyihalar{!isAdmin && ':'} {!isAdmin && ((p.projects || []).map(x => x.name).join(', ') || '—')}
              </div>
              {isAdmin && (
                <div className="flex flex-wrap gap-1">
                  {allProjects.map(pr => {
                    const on = (p.projects || []).some(x => x.id === pr.id);
                    return (
                      <button key={pr.id} onClick={() => toggleProject(p, pr.id)}
                        className={`text-[11px] px-2 py-0.5 rounded border ${on ? 'bg-primary-50 dark:bg-primary-900/30 border-primary-300 dark:border-primary-700 text-primary-800 dark:text-primary-300' : 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-700 text-gray-400'}`}>
                        {on ? '✓ ' : ''}{pr.name}
                      </button>
                    );
                  })}
                  {!allProjects.length && <span className="text-[11px] text-gray-400">loyiha yo'q</span>}
                </div>
              )}
            </div>
            {(() => {
              const linked = curPid && (p.projects || []).some(x => Number(x.id) === curPid);
              const shared = (p.projects || []).length > 1;
              if (!curPid && !shared) return null;
              return (
                <div className="flex flex-wrap items-center gap-1.5 mb-3">
                  {shared && <span className="text-[11px] px-2 py-0.5 rounded bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800" title={(p.projects || []).map(x => x.name).join(', ')}>🔗 umumiy · {(p.projects || []).length} loyiha</span>}
                  {curPid && canManage(curPid) && linked && shared && (
                    <button onClick={() => splitAccount(p)} title={`${curProjectName} uchun alohida login bilan yangi akkaunt — boshqa loyihalar eskisida qoladi`}
                      className="text-[11px] px-2 py-0.5 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700">✂️ {curProjectName} uchun ajratish</button>
                  )}
                  {curPid && canManage(curPid) && linked && (
                    <button onClick={() => linkProject(p, false)} className="text-[11px] px-2 py-0.5 rounded border border-gray-300 dark:border-gray-600 text-gray-500 hover:text-red-600 hover:border-red-300">➖ {curProjectName}dan olib tashlash</button>
                  )}
                  {curPid && canManage(curPid) && !linked && (
                    <button onClick={() => linkProject(p, true)} className="text-[11px] px-2 py-0.5 rounded border border-primary-300 dark:border-primary-700 text-primary-700 dark:text-primary-300 hover:bg-primary-50 dark:hover:bg-primary-900/30">➕ {curProjectName}ga biriktirish</button>
                  )}
                </div>
              );
            })()}
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => openSession(p.key, true)}
                disabled={busy === p.key}
                className="px-3 py-1.5 text-sm bg-primary-700 dark:bg-primary-600 text-white rounded disabled:opacity-50">
                {p.loggedIn === true ? '🖥 Konsolni ochish' : '🔐 Sessiyani ochish'}
              </button>
              <button
                onClick={() => checkSession(p.key)}
                disabled={busy === p.key}
                className="px-3 py-1.5 text-sm border rounded disabled:opacity-50">
                🔎 Tekshirish
              </button>
              {p.running && (
                <button
                  onClick={() => closeSession(p.key)}
                  disabled={busy === p.key}
                  className="px-3 py-1.5 text-sm border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 rounded disabled:opacity-50">
                  ⏹ Yopish
                </button>
              )}
              {(isAdmin || ((p.projects || []).length > 0 && (p.projects || []).every(x => myRoles[x.id] === 'owner'))) && (
                <button onClick={() => deleteAccount(p)}
                  className="px-3 py-1.5 text-sm border rounded text-gray-400 hover:text-red-600 dark:hover:text-red-300 hover:border-red-300 dark:hover:border-red-600 ml-auto">
                  🗑
                </button>
              )}
            </div>
          </div>
        ))}
        {!profiles.length && <div className="text-sm text-gray-500 dark:text-gray-400">Profillar yuklanmoqda…</div>}
        {profiles.length > 0 && curPid && !showAll && !profiles.some(p => (p.projects || []).some(x => Number(x.id) === curPid)) && (
          <div className="text-sm text-gray-500 dark:text-gray-400">{curProjectName}ga hali konsol biriktirilmagan — «Hammasi» dan mavjudini biriktiring yoki pastda yangisini qo'shing.</div>
        )}
      </div>

      {(isAdmin || canManage(curPid)) && (
        <div className="mb-6">
          {!newAcc ? (
            <button onClick={() => setNewAcc({ key: '', label: '', kind: (kinds[0] || {}).kind || 'google' })}
              className="px-3 py-1.5 text-sm border border-dashed rounded text-gray-600 dark:text-gray-400 hover:border-primary-500 hover:text-primary-700 dark:hover:text-primary-300">
              ➕ {curPid && !isAdmin ? `${curProjectName} uchun konsol akkaunti qo'shish` : "Akkaunt qo'shish"}
            </button>
          ) : (
            <div className="border-2 border-primary-200 dark:border-primary-800 rounded-lg p-4">
              <div className="font-semibold mb-1">➕ Yangi konsol akkaunti</div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
                Har akkaunt — alohida login (o'z brauzer sessiyasi). Bitta login bir nechta loyihada bo'lsa
                (masalan bitta Apple ID) — bitta akkaunt yetarli, boshqa loyihaga «➕ biriktirish». Login har loyihada
                boshqa bo'lsa (Payme, Google Play/Firebase) — har loyiha uchun alohida akkaunt.
                {curPid && <> Yangi akkaunt <b>{curProjectName}</b> loyihasiga biriktiriladi.</>}
              </p>
              <div className="flex flex-wrap gap-2 items-end">
                {isAdmin && (
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Kalit (lotin, '-' bilan; bo'sh — avtomatik)
                  <input value={newAcc.key} onChange={e => setNewAcc(a => ({ ...a, key: e.target.value }))}
                    placeholder="apple-tezhal" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-44" />
                </label>
                )}
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Nomi
                  <input value={newAcc.label} onChange={e => setNewAcc(a => ({ ...a, label: e.target.value }))}
                    placeholder="Apple — TezHal" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-56" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Turi
                  <select value={newAcc.kind} onChange={e => setNewAcc(a => ({ ...a, kind: e.target.value }))}
                    className="block mt-0.5 border rounded px-3 py-1.5 text-sm">
                    {kinds.map(k => <option key={k.kind} value={k.kind}>{k.label}</option>)}
                  </select>
                </label>
                <div className="text-[11px] text-gray-500 dark:text-gray-400 self-end pb-1.5 max-w-[22rem]">
                  Ro'yxatda kerakli xizmat yo'qmi? Pastdagi <b>«➕ Boshqa xizmat qo'shish»</b> bilan
                  yangi turini (Cloudflare, Contabo, SMS provayder…) qo'shing — keyin shu yerda chiqadi.
                </div>
                <button onClick={createAccount} className="px-3 py-1.5 text-sm bg-primary-700 dark:bg-primary-600 text-white rounded">💾 Qo'shish</button>
                <button onClick={() => setNewAcc(null)} className="px-3 py-1.5 text-sm border rounded">Bekor</button>
              </div>
            </div>
          )}
        </div>
      )}

      {isAdmin && (
        <div className="mb-6">
          {!newKind ? (
            <div className="flex items-center gap-2 flex-wrap">
              <button onClick={() => setNewKind({ kind: '', label: '', loginUrl: '', probeUrl: '', origins: '', hint: '' })}
                className="px-3 py-1.5 text-sm border border-dashed rounded text-gray-600 dark:text-gray-400 hover:border-primary-500 hover:text-primary-700 dark:hover:text-primary-300">
                ➕ Boshqa xizmat qo'shish
              </button>
              {kinds.filter(k => k.custom).map(k => (
                <span key={k.kind} className="text-[11px] bg-gray-100 dark:bg-gray-700 border rounded px-2 py-1 flex items-center gap-1">
                  {k.label}
                  <button onClick={() => removeKind(k)} title="Xizmatni o'chirish"
                    className="text-red-500 hover:text-red-700 dark:hover:text-red-300">🗑</button>
                </span>
              ))}
            </div>
          ) : (
            <div className="border-2 border-emerald-200 dark:border-emerald-800 rounded-lg p-4">
              <div className="font-semibold mb-1">➕ Yangi xizmat (konsol turi)</div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
                Masalan Cloudflare, Contabo, SMS provayder — istalgan boshqaruv paneli.
                Brauzer <b>faqat</b> siz sanagan domenlarda yura oladi; har akkaunt o'z profilida
                ishlaydi, shuning uchun mavjud Google/Apple sessiyalariga tegmaydi.
                Faqat <b>https</b> qabul qilinadi (IP manzil va localhost — yo'q).
              </p>
              <div className="flex flex-wrap gap-2 items-end">
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Kalit (lotin)
                  <input value={newKind.kind} onChange={e => setNewKind(k => ({ ...k, kind: e.target.value }))}
                    placeholder="cloudflare" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-40" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Nomi
                  <input value={newKind.label} onChange={e => setNewKind(k => ({ ...k, label: e.target.value }))}
                    placeholder="Cloudflare — DNS / CDN" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-56" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Kirish manzili
                  <input value={newKind.loginUrl} onChange={e => setNewKind(k => ({ ...k, loginUrl: e.target.value }))}
                    placeholder="https://dash.cloudflare.com/login" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-72" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Tekshirish manzili (ixtiyoriy)
                  <input value={newKind.probeUrl} onChange={e => setNewKind(k => ({ ...k, probeUrl: e.target.value }))}
                    placeholder="https://dash.cloudflare.com/" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-72" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400 w-full">Ruxsat etilgan domenlar (vergul bilan)
                  <input value={newKind.origins} onChange={e => setNewKind(k => ({ ...k, origins: e.target.value }))}
                    placeholder="dash.cloudflare.com, cloudflare.com" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-full" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400 w-full">Izoh (ixtiyoriy)
                  <input value={newKind.hint} onChange={e => setNewKind(k => ({ ...k, hint: e.target.value }))}
                    placeholder="DNS yozuvlari, SSL sozlamalari" className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-full" />
                </label>
                <button onClick={createKind} className="px-3 py-1.5 text-sm bg-emerald-600 text-white rounded">💾 Qo'shish</button>
                <button onClick={() => setNewKind(null)} className="px-3 py-1.5 text-sm border rounded">Bekor</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 🤖 "Men kiraman, qolganini sen qil" — operator login qiladi, agent qolganini bajaradi. */}
      {active && (
        <div className="border-2 border-primary-200 dark:border-primary-800 rounded-lg p-4 mb-4 bg-primary-50/30 dark:bg-primary-900/30">
          <div className="font-semibold mb-1">🤖 Qolganini Khorezmai bajarsin</div>
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-2">
            Avval shu konsolga <b>o'zingiz kiring</b> (parol/2FA — pastdagi jonli ekranda).
            Keyin nima qilish kerakligini yozing: agent navigatsiya qiladi, formalarni to'ldiradi,
            API yoqadi, kalit yaratadi. <b>Parol yozmaydi</b> va Publish/Delete kabi qaytarib
            bo'lmaydigan tugmalarni bosmaydi. 🔑 Topilgan kalit to'g'ridan-to'g'ri <b>Sirlar</b>ga
            saqlanadi — qiymati hech qayerda ko'rsatilmaydi.
          </p>
          {fromCard && (
            <div className="mb-2 text-xs bg-primary-50 dark:bg-primary-900/30 border border-primary-200 dark:border-primary-800 text-primary-900 dark:text-primary-200 rounded px-3 py-2 flex items-start gap-2">
              <span className="flex-1">
                📋 Reja kartasi: <b>{fromCard.todoTitle}</b> — {linkedCard && !cardCtx
                  ? 'ish shu kartaga bog\'landi, natija (agent hisoboti) o\'sha yerda ko\'rinadi.'
                  : 'ish tugagach natija (agent hisoboti) shu kartaga yoziladi.'}
              </span>
              <button onClick={() => { setCardCtx(null); setLinkedCard(null); }}
                title="Bu ishni kartadan uzish (boshqa, aloqasiz ish qilmoqchi bo'lsangiz)"
                className="text-primary-500 hover:text-primary-800 dark:hover:text-primary-200 shrink-0">✕</button>
            </div>
          )}
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="text-xs text-gray-500 dark:text-gray-400">🎯 Qaysi loyiha uchun:</span>
            <select value={runProject} onChange={(e) => setRunProject(e.target.value)}
              disabled={!!(consoleRun && consoleRun.running)}
              className="border rounded px-2 py-1 text-sm disabled:bg-gray-100 dark:disabled:bg-gray-700">
              <option value="">— tanlanmagan —</option>
              {allProjects.map(pr => <option key={pr.id} value={pr.id}>{pr.name}</option>)}
            </select>
            {/* Ish ketayotganda selektor bloklangan — shuning uchun ish QAYSI loyiha
                bilan ketayotganini ochiq aytamiz (ilgari bo'sh «tanlanmagan» turardi
                va operator nima bo'layotganini bilmasdi). */}
            {consoleRun && consoleRun.running && (
              consoleRun.projectId
                ? <span className="text-[11px] text-emerald-700 dark:text-emerald-400">
                    ▶ Ish loyihasi: <b>{(allProjects.find(p => String(p.id) === String(consoleRun.projectId)) || {}).name || ('#' + consoleRun.projectId)}</b>
                  </span>
                : <span className="text-[11px] text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 rounded px-2 py-1">
                    ⚠️ Bu ish loyihasiz ketmoqda — agent modul manzillarini va integratsiya hisobotini ko'rmaydi.
                  </span>
            )}
            {!runProject && !(consoleRun && consoleRun.running) && (
              <span className="text-[11px] text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 rounded px-2 py-1">
                ⚠️ Tanlanmasa agent modul manzillarini va integratsiya hisobotini ko'rmaydi — Endpoint URL kabi narsalarni sizdan so'raydi.
              </span>
            )}
          </div>
          {(() => {
            const acc = profiles.find(p => p.key === active);
            const kd = acc && kinds.find(k => k.kind === acc.kind);
            if (!kd || !kd.playbook) return null;
            return (
              <div className="mb-2 text-[11px] bg-emerald-50 dark:bg-emerald-900/25 border border-emerald-200 dark:border-emerald-800 rounded px-2 py-1.5">
                <button onClick={() => setShowPlaybook(v => !v)} className="text-emerald-800 dark:text-emerald-300 hover:underline">
                  {showPlaybook ? '▾' : '▸'} 📋 Bu konsol uchun tartib biriktirilgan — agent qadamlarni allaqachon biladi
                </button>
                {showPlaybook && (
                  <pre className="mt-1.5 whitespace-pre-wrap text-[11px] leading-relaxed text-gray-700 dark:text-gray-300 max-h-64 overflow-auto">{kd.playbook}</pre>
                )}
                {!showPlaybook && (
                  <div className="text-gray-600 dark:text-gray-400 mt-0.5">Qisqa yozsangiz ham bo'ladi (masalan «TezHal uchun kassa och») — qolganini tartibdan oladi.</div>
                )}
              </div>
            );
          })()}
          <div className="flex gap-2 items-start">
            <textarea
              value={wish} onChange={(e) => setWish(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) startRun(); }}
              rows={2} disabled={!!(consoleRun && consoleRun.running)}
              placeholder="Masalan: Google Cloud'da Maps SDK for Android va Geocoding API'ni yoq, yangi API kalit yarat va uni GOOGLE_MAPS_API_KEY nomi bilan saqla"
              className="flex-1 border rounded px-3 py-2 text-sm resize-y min-h-[52px] disabled:bg-gray-100 dark:disabled:bg-gray-700"
            />
            <button
              onClick={startRun}
              disabled={starting || wish.trim().length < 5 || !!(consoleRun && consoleRun.running)}
              className="px-4 py-2 rounded bg-primary-700 dark:bg-primary-600 text-white text-sm font-semibold hover:bg-primary-800 dark:hover:bg-primary-700 disabled:opacity-50 whitespace-nowrap">
              {(consoleRun && consoleRun.running) ? '⏳ Ishlamoqda…' : (starting ? '⏳' : '▶ Boshlash')}
            </button>
            {agentBusy && (
              <button onClick={stopAgent} disabled={stopping || (consoleRun && consoleRun.stopping)}
                className="px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-semibold disabled:opacity-50 whitespace-nowrap">
                {stopping || (consoleRun && consoleRun.stopping) ? '⏳ To\'xtatilmoqda…' : '⏹ To\'xtatish'}
              </button>
            )}
          </div>

          {ask && (
            <div className="mt-3 rounded-lg border-2 border-primary-400 dark:border-primary-600 bg-primary-50 dark:bg-primary-900/25 p-3">
              <div className="text-xs font-semibold text-primary-800 dark:text-primary-200 mb-1">💬 Agent savol bermoqda</div>
              <div className="text-sm text-gray-800 dark:text-gray-100 whitespace-pre-wrap mb-2">{ask.question}</div>
              {(ask.options || []).length > 0 && (
                <div className="flex gap-2 flex-wrap mb-2">
                  {ask.options.map((o, i) => (
                    <button key={i} disabled={answering} onClick={() => sendAnswer(o)}
                            className="px-3 py-1.5 rounded-lg bg-primary-700 dark:bg-primary-600 text-white text-xs font-semibold hover:bg-primary-800 disabled:opacity-50">
                      {o}
                    </button>))}
                </div>
              )}
              <div className="flex gap-2">
                <input value={answer} onChange={e => setAnswer(e.target.value)}
                       onKeyDown={e => { if (e.key === 'Enter') sendAnswer(answer); }}
                       disabled={answering}
                       placeholder={(ask.options || []).length ? 'Yoki o\'z javobingizni yozing…' : 'Javobingizni yozing…'}
                       className="flex-1 border border-gray-300 dark:border-gray-600 dark:bg-gray-900 rounded-lg px-3 py-1.5 text-sm" />
                <button onClick={() => sendAnswer(answer)} disabled={answering || !answer.trim()}
                        className="px-3 py-1.5 rounded-lg bg-primary-700 dark:bg-primary-600 text-white text-sm disabled:opacity-50">
                  {answering ? '⏳' : 'Yuborish'}
                </button>
              </div>
              <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-1.5">
                Agent javobingizni kutib turibdi. Telegram'ga ham yuborildi — u yerdan ham javob bera olasiz.
              </div>
            </div>
          )}

          {consoleRun && (consoleRun.log || []).length > 0 && (
            <div className="mt-3 bg-white dark:bg-gray-800 border rounded p-2 max-h-40 overflow-auto">
              {consoleRun.log.map((l, i) => (
                <div key={i} className={`text-[11px] leading-relaxed ${l.kind === 'error' ? 'text-red-600 dark:text-red-400' : l.kind === 'success' ? 'text-emerald-700 dark:text-emerald-400' : l.kind === 'ask' ? 'text-primary-700 dark:text-primary-300 font-semibold' : 'text-gray-600 dark:text-gray-400'}`}>
                  {l.m}
                </div>
              ))}
            </div>
          )}

          {consoleRun && consoleRun.result && !consoleRun.running && (
            <div className={`mt-3 text-xs rounded border px-3 py-2 ${consoleRun.result.needLogin ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300' : consoleRun.result.ok ? 'bg-emerald-50 dark:bg-emerald-900/30 border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-300' : 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300'}`}>
              <div className="font-semibold mb-1">
                {consoleRun.result.needLogin ? '🔐 Avval konsolga kiring' : consoleRun.result.ok ? '✅ Bajarildi' : '⚠️ To\'liq bajarilmadi'}
              </div>
              {consoleRun.result.summary && <div className="whitespace-pre-wrap">{consoleRun.result.summary}</div>}
              {(consoleRun.result.savedSecrets || []).length > 0 && (
                <div className="mt-1">🔑 Sirlarga saqlandi: <b>{consoleRun.result.savedSecrets.join(', ')}</b></div>
              )}
              {(consoleRun.result.operatorTodo || []).length > 0 && (
                <div className="mt-1">
                  👤 Sizga qoldi:
                  <ul className="list-disc ml-5">{consoleRun.result.operatorTodo.map((t, i) => <li key={i}>{t}</li>)}</ul>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {active && (
        <div className="border rounded-lg p-4">
          <div className="flex items-center justify-between mb-1">
            <div className="font-semibold">🖥 Jonli ekran — {active}</div>
            <div className="flex items-center gap-3">
              <button onClick={() => setFullscreen(true)} className="text-sm text-primary-700 dark:text-primary-500 hover:text-primary-900 dark:hover:text-primary-200 font-medium">⛶ To'liq ekran</button>
              <button onClick={() => setActive(null)} className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">
                Ko'rinishni yopish
              </button>
            </div>
          </div>
          {/* 🔗 Manzil qatori — brauzerdagidek. Agent qayerga o'tgani ko'rinib tursin. */}
          <div className="flex items-center gap-2 mb-2 text-[11px]">
            <span className="text-gray-400 shrink-0">🔗</span>
            <span className="font-mono text-gray-600 dark:text-gray-400 truncate flex-1" title={pageUrl || ''}>
              {pageUrl || 'manzil aniqlanmadi'}
            </span>
            {pageUrl && (
              <button
                onClick={() => { try { navigator.clipboard.writeText(pageUrl); setMsg('🔗 Manzil nusxalandi'); } catch (e) {} }}
                title="Manzildan nusxa olish"
                className="shrink-0 px-1.5 py-0.5 rounded border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700">⧉</button>
            )}
          </div>
          {/* 🔑 Kirish — saqlangan login/parol bilan (server o'zi yozadi; docs 167) */}
          {cred && (cred.saved || cred.canManage) && !credForm && (
            <div className="mb-2 flex flex-wrap items-center gap-2">
              {cred.saved && (
                <button onClick={credLogin} disabled={credBusy || agentBusy || !cred.canManage}
                  title="Saqlangan login va parolni server o'zi login formasiga yozadi — parol hech qayerda ko'rinmaydi. SMS kodini o'zingiz kiritasiz."
                  className="text-xs px-3 py-1 rounded bg-emerald-600 hover:bg-emerald-700 text-white font-semibold disabled:opacity-50">
                  {credBusy ? '⏳ Kirilmoqda…' : '🔑 Kirish'}
                </button>
              )}
              {cred.saved && <span className="text-[11px] text-gray-500 dark:text-gray-400" translate="no">{cred.loginHint}</span>}
              {cred.canManage && (
                <button onClick={() => setCredForm({ login: '', password: '' })}
                  className="text-[11px] px-2 py-1 rounded border border-dashed border-emerald-300 dark:border-emerald-700 text-emerald-700 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/40">
                  {cred.saved ? "⚙ Kirish ma'lumotini almashtirish" : "🔐 Kirish ma'lumotini saqlash"}
                </button>
              )}
            </div>
          )}
          {credForm && (
            <div className="mb-2 border-2 border-emerald-200 dark:border-emerald-800 rounded-lg p-3 bg-emerald-50/40 dark:bg-emerald-900/30">
              <div className="text-[11px] text-gray-600 dark:text-gray-400 mb-2">
                Login va parol <b>shifrlab</b> saqlanadi va hech qayerda <b>ko'rsatilmaydi</b>. «🔑 Kirish» bosilganda server ularni
                faqat shu konsolning kirish sahifasiga{cred && cred.origin ? <span translate="no"> ({cred.origin})</span> : null} yozadi.
                AI agent ulardan foydalana olmaydi. SMS kodini o'zingiz kiritasiz.
              </div>
              <form onSubmit={(e) => { e.preventDefault(); saveCred(); }} autoComplete="off" className="flex flex-wrap gap-2 items-end">
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Telefon yoki email
                  <input value={credForm.login} onChange={e => setCredForm(f => ({ ...f, login: e.target.value }))}
                    autoComplete="off" placeholder="998901234567"
                    className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-56 font-mono" />
                </label>
                <label className="text-[11px] text-gray-500 dark:text-gray-400">Parol
                  <input type="password" value={credForm.password} onChange={e => setCredForm(f => ({ ...f, password: e.target.value }))}
                    autoComplete="new-password"
                    className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-56" />
                </label>
                <button type="submit" disabled={credBusy} className="px-3 py-1.5 text-sm bg-emerald-600 text-white rounded font-semibold disabled:opacity-50">🔐 Saqlash</button>
                <button type="button" onClick={() => setCredForm(null)} className="px-3 py-1.5 text-sm border rounded">Bekor</button>
                {cred && cred.saved && (
                  <button type="button" onClick={deleteCred} disabled={credBusy}
                    className="px-3 py-1.5 text-sm border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 rounded">🗑 O'chirish</button>
                )}
              </form>
            </div>
          )}
          {/* 🔑 Kalitni qo'lda ko'chirmaslik uchun */}
          <div className="mb-2">
            {!grab ? (
              <button onClick={openGrab}
                title="Ekrandagi kalitni qo'lda ko'chirmasdan Sirlarga saqlash"
                className="text-[11px] px-2 py-1 rounded border border-dashed border-amber-300 dark:border-amber-700 text-amber-700 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/40">
                🔑 Ekrandagi kalitni Sirlarga saqlash
              </button>
            ) : (
              <div className="border-2 border-amber-200 dark:border-amber-800 rounded-lg p-3 bg-amber-50/40 dark:bg-amber-900/30">
                <div className="text-[11px] text-gray-600 dark:text-gray-400 mb-2">
                  Kalitni qo'lda ko'chirmang. Ekranda <b>kalit turgan maydonni bosing</b> (yoki matnni
                  belgilang, yoki sahifaning o'z «nusxa olish» tugmasini bosing), keyin nom berib saqlang.
                  Qiymat serverdan to'g'ridan-to'g'ri <b>Sirlar</b>ga yoziladi — bu yerda <b>ko'rsatilmaydi</b>.
                </div>
                <div className="flex flex-wrap gap-2 items-end">
                  <label className="text-[11px] text-gray-500 dark:text-gray-400">Sir nomi
                    <input value={grab.name} onChange={e => setGrab(g => ({ ...g, name: e.target.value }))}
                      placeholder="GOOGLE_MAPS_API_KEY"
                      className="block mt-0.5 border rounded px-3 py-1.5 text-sm w-60 font-mono" />
                  </label>
                  <label className="text-[11px] text-gray-500 dark:text-gray-400">Modul
                    <select value={grab.moduleId} onChange={e => setGrab(g => ({ ...g, moduleId: e.target.value }))}
                      className="block mt-0.5 border rounded px-3 py-1.5 text-sm max-w-[16rem]">
                      <option value="">— tanlang —</option>
                      {grabMods.map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
                    </select>
                  </label>
                  <label className="text-[11px] text-gray-500 dark:text-gray-400">Qayerda
                    <select value={grab.scope} onChange={e => setGrab(g => ({ ...g, scope: e.target.value }))}
                      className="block mt-0.5 border rounded px-3 py-1.5 text-sm">
                      <option value="both">test + production</option>
                      <option value="test">faqat test</option>
                      <option value="prod">faqat production</option>
                    </select>
                  </label>
                  <button onClick={grabSecret} className="px-3 py-1.5 text-sm bg-amber-600 text-white rounded font-semibold">🔑 Saqlash</button>
                  <button onClick={() => setGrab(null)} className="px-3 py-1.5 text-sm border rounded">Bekor</button>
                </div>
                {!grabMods.length && <div className="text-[11px] text-red-500 mt-2">Bu akkauntga bog'langan loyihada modul topilmadi — kartadagi loyiha chiplaridan bog'lang.</div>}
              </div>
            )}
          </div>
          <div data-kb="1" ref={kbRef} tabIndex={0} onKeyDown={onFrameKeyDown} onPaste={onFramePaste}
            onFocus={() => setKbFocus(true)} onBlur={() => { flushType(); setKbFocus(false); }}
            className={`bg-black rounded overflow-hidden relative outline-none ${kbFocus ? 'ring-2 ring-emerald-500' : ''}`}>
            {frameUrl ? (
              <img
                src={frameUrl}
                alt="konsol"
                draggable={false}
                onMouseDown={onFrameMouseDown}
                onMouseUp={onFrameMouseUp}
                onWheel={onFrameWheel}
                style={{ width: '100%', display: 'block', cursor: agentBusy ? 'not-allowed' : 'text', userSelect: 'none' }}
              />
            ) : (
              <div className="text-gray-400 text-sm p-10 text-center">Kadr kutilmoqda…</div>
            )}
            {agentBusy && frameUrl && (
              <div className="absolute left-2 right-2 top-2 flex items-center gap-2 flex-wrap bg-gray-900/85 text-white text-xs rounded-lg px-3 py-2 shadow">
                <span className="font-semibold">🤖 Agent ishlayapti — boshqaruv qulflangan</span>
                <span className="opacity-75">(siz faqat kuzatasiz)</span>
                <button onClick={stopAgent} disabled={stopping || (consoleRun && consoleRun.stopping)}
                  className="ml-auto px-2.5 py-1 rounded bg-red-600 hover:bg-red-700 font-semibold disabled:opacity-50">
                  {stopping || (consoleRun && consoleRun.stopping) ? '⏳ To\'xtatilmoqda…' : '✋ Agentni to\'xtatib, boshqaruvni olish'}
                </button>
              </div>
            )}
            {frameUrl && !agentBusy && kbBadge}
            {/* ⬆⬇ Scroll — kadr ustida g'ildirak ishlamasa yoki tugma qulayroq bo'lsa. */}
            {frameUrl && (
              <div className="absolute right-2 bottom-2 flex flex-col gap-1">
                <button onClick={() => sendScroll('up')} title="Yuqoriga" className="w-9 h-9 bg-white/85 hover:bg-white dark:hover:bg-gray-700 text-gray-900 dark:text-white rounded-full border border-gray-200 dark:border-gray-700 shadow-sm text-lg leading-none">⬆</button>
                <button onClick={() => sendScroll('down')} title="Pastga" className="w-9 h-9 bg-white/85 hover:bg-white dark:hover:bg-gray-700 text-gray-900 dark:text-white rounded-full border border-gray-200 dark:border-gray-700 shadow-sm text-lg leading-none">⬇</button>
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-2 mt-3 items-center">
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); sendText(); } }}
              placeholder={agentBusy ? '🤖 Agent ishlayapti — boshqaruv qulflangan' : 'Matn yozish (parolni ham shu yerdan)…'}
              disabled={agentBusy}
              className="border rounded px-3 py-1.5 text-sm flex-1 min-w-[220px] disabled:bg-gray-100 dark:disabled:bg-gray-700"
            />
            <button onClick={sendText} className="px-3 py-1.5 text-sm border rounded">⌨️ Yozish</button>
            <button onClick={() => sendKey('Enter')} className="px-3 py-1.5 text-sm border rounded">↵ Enter</button>
            <button onClick={() => sendKey('Tab')} className="px-3 py-1.5 text-sm border rounded">⇥ Tab</button>
            <button onClick={() => sendKey('Escape')} className="px-3 py-1.5 text-sm border rounded">Esc</button>
            <button onClick={() => sendScroll('up')} className="px-3 py-1.5 text-sm border rounded">⬆ Scroll</button>
            <button onClick={() => sendScroll('down')} className="px-3 py-1.5 text-sm border rounded">⬇ Scroll</button>
            <button onClick={reloadPage} disabled={reloading} title="Sahifani qayta yuklash (F5) — qotib qolsa" className="px-3 py-1.5 text-sm border rounded disabled:opacity-50">{reloading ? '⏳' : '⟳'} Yangilash</button>
            <button onClick={copyFromConsole} title="Konsol sahifasida belgilangan matnni (sudrab yoki 2 marta bosib belgilang) o'z clipboard'ingizga olish — keyin emulator yoki kompyuterga qo'yasiz" className="px-3 py-1.5 text-sm border rounded">📋 Nusxa olish</button>
          </div>
          <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-2">
            Ekranga bosing — bosish serverdagi brauzerga uzatiladi va klaviatura konsolga ulanadi: to'g'ridan-to'g'ri
            yozing, ⌘V / Ctrl+V bilan qo'ying. Matnni belgilang (sudrab yoki 2–3 marta bosib) va ⌘C / Ctrl+C yoki
            «📋 Nusxa olish» — u sizning clipboard'ingizga tushadi. Kirib bo'lgach «🔎 Tekshirish» ni bosing:
            sessiya tasdiqlansa salomatlik kuzatuvi avtomatik yoqiladi.
          </div>
        </div>
      )}

      {/* ⛶ TO'LIQ EKRAN — emulatordagi kabi; brauzer katta ko'rinadi, bosish/scroll/matn ishlaydi */}
      {fullscreen && active && (
        <div className="fixed inset-0 z-[60] bg-black flex flex-col">
          <div className="flex items-center gap-2 px-3 py-2 bg-gray-900 text-white shrink-0 flex-wrap">
            <span className="text-sm font-semibold mr-1">🖥 {active}</span>
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); sendText(); } }}
              placeholder={agentBusy ? '🤖 Agent ishlayapti — qulflangan' : 'Matn (parolni ham shu yerdan)…'}
              disabled={agentBusy}
              className="border border-gray-600 bg-gray-800 text-white rounded px-3 py-1 text-sm flex-1 min-w-[180px] disabled:opacity-50"
            />
            <button onClick={sendText} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">⌨️ Yozish</button>
            <button onClick={() => sendKey('Enter')} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">↵</button>
            <button onClick={() => sendKey('Tab')} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">⇥</button>
            <button onClick={() => sendKey('Escape')} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">Esc</button>
            <button onClick={() => sendScroll('up')} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">⬆</button>
            <button onClick={() => sendScroll('down')} className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">⬇</button>
            <button onClick={reloadPage} disabled={reloading} title="Sahifani qayta yuklash (F5) — qotib qolsa" className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded disabled:opacity-50">{reloading ? '⏳' : '⟳'}</button>
            <button onClick={copyFromConsole} title="Belgilangan matnni o'z clipboard'ingizga olish" className="px-2.5 py-1 text-sm bg-gray-700 hover:bg-gray-600 rounded">📋 Nusxa</button>
            <button onClick={() => setFullscreen(false)} className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 rounded font-semibold ml-auto">✕ Chiqish</button>
          </div>
          <div className="px-3 pb-2 text-[11px] font-mono text-gray-400 truncate" title={pageUrl || ''}>
            🔗 {pageUrl || 'manzil aniqlanmadi'}
          </div>
          <div data-kb="1" ref={kbRef} tabIndex={0} onKeyDown={onFrameKeyDown} onPaste={onFramePaste}
            onFocus={() => setKbFocus(true)} onBlur={() => { flushType(); setKbFocus(false); }}
            className="flex-1 relative overflow-hidden flex items-center justify-center outline-none">
            {frameUrl ? (
              <img
                src={frameUrl}
                alt="konsol"
                draggable={false}
                onMouseDown={onFrameMouseDown}
                onMouseUp={onFrameMouseUp}
                onWheel={onFrameWheel}
                style={{ maxWidth: '100%', maxHeight: '100%', display: 'block', cursor: agentBusy ? 'not-allowed' : 'text', userSelect: 'none' }}
              />
            ) : (
              <div className="text-gray-400 text-sm">Kadr kutilmoqda…</div>
            )}
            {agentBusy && frameUrl && (
              <div className="absolute left-4 right-4 top-4 flex items-center gap-2 flex-wrap bg-gray-900/85 text-white text-xs rounded-lg px-3 py-2 shadow">
                <span className="font-semibold">🤖 Agent ishlayapti — boshqaruv qulflangan</span>
                <span className="opacity-75">(siz faqat kuzatasiz)</span>
                <button onClick={stopAgent} disabled={stopping || (consoleRun && consoleRun.stopping)}
                  className="ml-auto px-2.5 py-1 rounded bg-red-600 hover:bg-red-700 font-semibold disabled:opacity-50">
                  {stopping || (consoleRun && consoleRun.stopping) ? '⏳ To\'xtatilmoqda…' : '✋ Agentni to\'xtatib, boshqaruvni olish'}
                </button>
              </div>
            )}
            {frameUrl && !agentBusy && kbBadge}
            <div className="absolute right-4 bottom-4 flex flex-col gap-2">
              <button onClick={() => sendScroll('up')} title="Yuqoriga" className="w-11 h-11 bg-white/85 hover:bg-white dark:hover:bg-gray-700 text-gray-900 dark:text-white rounded-full shadow-lg text-xl leading-none">⬆</button>
              <button onClick={() => sendScroll('down')} title="Pastga" className="w-11 h-11 bg-white/85 hover:bg-white dark:hover:bg-gray-700 text-gray-900 dark:text-white rounded-full shadow-lg text-xl leading-none">⬇</button>
            </div>
          </div>
        </div>
      )}
      {clipToast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[70] max-w-[90vw] bg-gray-900 text-white text-sm rounded-lg shadow-lg px-4 py-2 flex items-center gap-3">
          {clipToast.copied ? (
            <span>📋 Sayt nusxalagan matn clipboard'ingizda ({clipToast.text.length} belgi) — emulator yoki kompyuterga qo'yishingiz mumkin</span>
          ) : (
            <>
              <span className="truncate">📋 Sayt nusxa oldi: <span translate="no" className="font-mono">{clipToast.text.length > 40 ? clipToast.text.slice(0, 40) + '…' : clipToast.text}</span></span>
              <button
                onClick={async () => { const ok = await writeClip(clipToast.text); setClipToast(ok ? { ...clipToast, copied: true } : clipToast); if (ok) setTimeout(() => setClipToast(null), 3000); }}
                className="px-2.5 py-1 bg-primary-600 hover:bg-primary-700 rounded font-semibold whitespace-nowrap">📋 Clipboard'ga olish</button>
            </>
          )}
          <button onClick={() => setClipToast(null)} className="text-gray-400 hover:text-white">✕</button>
        </div>
      )}
    </div>
  );
}
